import  gql  from 'graphql-tag'

export const CREATE_USER = gql`mutation userCreation($input: UserCreationMutationInput!){
    userCreation(input: $input){
        user{
            id
            name
            surname
            username
            email
            isActive
            authSystem
            group{
                    id
                    name  
                
            }
        }
        errors{
            field
            messages
        }
    }
}`;